<template>
  <div class="">
    <b-card title="应用管理" class="mb-0">
      <div style="margin-left: -1.5rem; margin-right: -1.5rem;">
        <div class="m-sm-2 m-1">
          <b-row>
            <!-- 页行数 -->
            <b-col
              cols="7"
              md="6"
              class="d-flex align-items-center justify-content-start"
            >
              <label>显示</label>
              <v-select
                v-model="perPage"
                :options="perPageOptions"
                :clearable="false"
                class="per-page-selector d-inline-block mx-50"
                @input="changePerPage"
              />
              <label>条</label>
            </b-col>
            <!-- 搜索框 -->
            <b-col cols="5" md="6">
              <div class="d-flex align-items-center justify-content-end">
                <b-button variant="primary" @click="operate">
                  <span class="text-nowrap">添加应用</span>
                </b-button>
              </div>
            </b-col>
          </b-row>
        </div>
        <!-- 表格 -->
        <b-table
          ref="refUserListTable"
          class="position-relative"
          :items="tableData"
          responsive
          :fields="tableColumns"
          primary-key="id"
          show-empty
          :empty-text="!loading ? '暂无数据' : '数据加载中...'"
          :no-provider-paging="false"
          stacked="md"
        >
          <template v-slot:cell(index)="data">
            {{ data.index + 1 }}
          </template>
          <template v-slot:cell(status)="data">
            <b-badge
              v-if="data.value == 1"
              href="javascript:void(0)"
              variant="success"
              >启用</b-badge
            >
            <b-badge v-else href="javascript:void(0)" variant="danger"
              >禁用</b-badge
            >
          </template>
          <template v-slot:cell(actions)="data">
            <div style="min-width: 11rem;">
              <a class="mr-1" href="javascript:void(0)" @click="operate(data)"
                >修改</a
              >
              <a class="mr-1" href="javascript:void(0)" @click="scope(data)"
                >权限管理</a
              >
              <a href="javascript:void(0)" @click="del(data)">删除</a>
            </div>
          </template>
        </b-table>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="
              d-flex
              align-items-center
              justify-content-center justify-content-sm-start
            "
            >
              <span class="text-muted">
                {{ (page - 1) * perPage + 1 }} /
                {{ page * perPage >= totalRows ? totalRows : page * perPage }}
                共 {{ totalRows }} 条</span
              >
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="
              d-flex
              align-items-center
              justify-content-center justify-content-sm-end
            "
            >
              <b-pagination
                v-model="page"
                :total-rows="totalRows"
                :per-page="perPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
                @change="changePage"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BSidebar,
} from "bootstrap-vue";
import vSelect from "vue-select";
import moment from "moment";

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BSidebar,
    vSelect,
  },
  data() {
    return {
      page: 1,
      perPage: 10,
      totalRows: 0,
      perPageOptions: [10, 20, 50, 100],
      tableData: [],
      tableColumns: [
        {
          key: "name",
          label: "应用名称",
          sortable: true,
        },
        {
          key: "detail",
          label: "应用描述",
          sortable: true,
        },
        {
          key: "status",
          label: "状态",
          sortable: true,
        },
        {
          key: "time",
          label: "时间",
          sortable: true,
        },
        {
          key: "actions",
          label: "操作",
        },
      ],
      loading: false,
      showDetail: false,
    };
  },
  created() {
    if (this.$route.name == this.OperateRouterName) {
      this.showDetail = true;
    }
    var token = this.$getToken();
    if (token && token.profile && token.profile.is_root === 1) {
      this.tableColumns.unshift({
        key: "user_name",
        label: "用户名",
        sortable: true,
      });
      this.tableColumns.unshift({
        key: "company_name",
        label: "公司名称",
        sortable: true,
      });
    }
    this.loadData();
  },
  methods: {
    loadData() {
      this.tableData = [];
      this.loading = true;
      this.$http
        .get("/App/GetAppList", {
          params: {
            page: this.page,
            size: this.perPage,
          },
        })
        .then((u) => {
          u.Data.forEach((z) => {
            z.time = moment(z.time).format("YYYY/MM/DD HH:mm:ss");
          });
          this.loading = false;
          this.tableData = u.Data;
          this.totalRows = u.Count;
        })
        .catch((u) => {
          this.loading = false;
        });
    },
    changePage(e) {
      this.page = e;
      this.loadData();
    },
    changePerPage(a) {
      this.page = 1;
      this.loadData();
    },
    operate(data) {
      var id = data && data.item ? data.item.id : undefined;
      this.$router.push({
        name: "AppEdit",
        params: {
          id,
        },
      });
    },
    scope(data) {
      var id = data && data.item ? data.item.id : undefined;
      if (!id) {
        this.$alertError("缺少权限参数");
        return;
      }
      this.$router.push({
        name: "AppScope",
        params: {
          id,
        },
        query: {
          name: data.item.name,
        },
      });
    },
    del(data) {
      this.$confirm("确定要删除该条记录吗？").then(() => {
        this.$http
          .get("/App/DeleteApp", {
            params: {
              id: data.item.id,
            },
          })
          .then((u) => {
            this.loadData();
            this.$alertSuccess("删除应用成功");
          });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>
